import { Component, OnInit, ChangeDetectionStrategy, inject, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectReferenceLayer } from '../state/filter-component.selectors';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { SpatialFilterCrudService } from '../services/spatial-filter-crud.service';
import { ReferenceLayerService } from '../services/reference-layer.service';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'tm-spatial-filter-form-select-reference-layer',
    templateUrl: './spatial-filter-form-select-reference-layer.component.html',
    styleUrls: ['./spatial-filter-form-select-reference-layer.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatFormField,
        MatLabel,
        MatSelect,
        ReactiveFormsModule,
        MatOption,
        AsyncPipe,
    ],
})
export class SpatialFilterFormSelectReferenceLayerComponent implements OnInit, OnDestroy {

  private destroyed = new Subject();
  private store$ = inject(Store);
  private filterCrudService = inject(SpatialFilterCrudService);
  private referenceLayerService = inject(ReferenceLayerService);

  public referencableLayers$ = this.referenceLayerService.referencableLayers$;
  public referenceLayerControl = new FormControl<string | undefined>(undefined, {
    nonNullable: true,
  });

  public ngOnInit(): void {
    this.store$.select(selectReferenceLayer)
      .pipe(takeUntil(this.destroyed))
      .subscribe((layer) => {
        this.referenceLayerControl.patchValue(layer, { emitEvent: false });
      });
    this.referenceLayerControl.valueChanges
      .pipe(takeUntil(this.destroyed))
      .subscribe((value) => {
        this.filterCrudService.updateReferenceLayer(value);
      });
  }

  public ngOnDestroy(): void {
    this.destroyed.next(null);
    this.destroyed.complete();
  }

}
